/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaContentSectionFragment} from '@amblique/contentful/app/contentful/fragments/media-content-section/base-media-content-section.fragment';
import {BaseIconFragment} from '@amblique/contentful/app/contentful/fragments/icon/base-icon.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';
import {BaseVideoFragment} from '@amblique/contentful/app/contentful/fragments/video/base-video.fragment';

export const MediaContentSectionFragment = gql`
  ${BaseIconFragment}
  ${BaseImageFragment}
  ${BaseMediaContentSectionFragment}
  ${BaseVideoFragment}

  fragment MediaContentSectionFragment on MediaContentSection {
    ...BaseMediaContentSectionFragment

    media {
      ... on Icon {
        ...BaseIconFragment
      }
      ... on Image {
        ...BaseImageFragment
      }
      ... on Video {
        ...BaseVideoFragment
      }
    }
  }
`;
